import React, {ReactNode} from 'react';
import {FieldValues, SubmitHandler, useFormContext} from 'react-hook-form';
import {whitespacesAsNull} from '@services/baseApi';

export interface IFormProps<TFormValues extends FieldValues> extends Omit<React.FormHTMLAttributes<HTMLFormElement>, 'onSubmit'> {
    onSubmit: SubmitHandler<TFormValues>;
    children: ReactNode;
}

function Form<TFormValues extends FieldValues>({onSubmit, children, ...formProps}: Readonly<IFormProps<TFormValues>>) {
    const methods = useFormContext<TFormValues>();
    const submitWrapper: SubmitHandler<TFormValues> = (data, ...rest) => {
        const sanitized = whitespacesAsNull(data);
        onSubmit?.(sanitized, ...rest);
    };
    return (
        <form
            {...formProps}
            onSubmit={(e) => void methods.handleSubmit(submitWrapper)(e)}
            style={{flexGrow: 1, maxWidth: 1200}}>
            {children}
        </form>
    );
}

export default Form;
